
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AuthenticationContext } from "vue-adal";
import axios from "axios";

import { EventBus } from "./../helpers/EventBus";

@Component({
  components: {},
})
export default class Plugins extends Vue {
  private static async cvtBLOB2Base64_(b) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (reader.result == null) {
          reject();
          return;
        }
        if (typeof reader.result !== "string") {
          reject();
          return;
        }
        const i = reader.result.indexOf(",");
        resolve(reader.result.substr(i + 1));
      };
      reader.readAsDataURL(b);
    });
  }

  public isBusy = false;
  public addingNewVersion = false;
  public pluginFile: any = null;
  public selectedVersion: any = this.emptyVersion();

  public filter: string = "";
  public fields = [
    {
      key: "Version",
      label: "Version",
      sortable: true,
    },
  ];
  public totalRows = 1;
  public versionsAvailable: any[] = [];
  public isSaveButtonEnabled = true;
  public hostname: string = "";
  public uploadPercentage = 0;

  public mounted() {
    this.hostname = Vue.prototype.$hostMode;

    EventBus.$on("mode-changed", (mode) => {
      this.hostname = mode;
      this.loadVersions();
    });

    this.loadVersions();
    document
      .querySelectorAll(".tableFixHead")
      .forEach((el) => el.addEventListener("scroll", this.tableFixHead));
  }

  @Watch("pluginFile")
  public fileChanged(val: any, oldVal: any) {
    this.setSelectedInstallerBLOB_(val);
    this.selectedVersion.SaveInstaller = true;
  }

  public tableFixHead(e) {
    const el = e.target;
    const sT = el.scrollTop;
    el.querySelectorAll("thead th").forEach(
      (th) => (th.style.transform = `translateY(${sT}px)`)
    );
  }

  public startCreateNewVersion() {
    this.selectedVersion.Version = "";
    this.selectedVersion.ReleaseNotes = "";
    this.addingNewVersion = true;
    this.selectedVersion.InstallerSizeText = "none";
    this.selectedVersion.InstallerBLOB = null;

    (this.$refs.versionTable as any).clearSelected();
    return true;
  }

  public emptyVersion() {
    return {
      Version: "",
      InstallerBLOB: null,
      InstallerSizeText: null,
      ReleaseNotes: "",
      SaveInstaller: false,
    };
  }
  public loadVersions() {
    this.isBusy = true;
    this.addingNewVersion = false;
    const client = this.hostname === "ers" ? "ERSPowerpoint" : "GenieBot";
    const url = `/api/v4/OfficePlugins/${client}`;

    axios.get(`/api/v4/Client/Installers/${client}`).then(
      (response) => {
        this.processVersionsAvailable_(response.data);
        this.isBusy = false;
      },
      (error) => {}
    );
  }

  public get directDownloadLink() {
    const client = this.hostname === "ers" ? "ERSPowerpoint" : "GenieBot";
    const link =
      `${process.env.VUE_APP_API_BASE_URL}` +
      `/api/v4/Client/Installer/${client}/${this.selectedVersion.Version}` +
      `?return=msi-only`;
    return link;
  }

  public copyLink() {
    const linkToCopy = document.querySelector("#direct-link") as any;
    if (linkToCopy) {
      linkToCopy.select();
      document.execCommand("copy");
    }
  }

  public displayEditBox() {
    if (this.addingNewVersion) {
      return true;
    }
    if (this.selectedVersion.Version === "") {
      return false;
    }
    return true;
  }

  // public async isSaveButtonEnabled() {
  //     let l = this.selectedUnchangedVersion;
  //     let r = this.selectedVersion;
  //     const result = JSON.stringify(l)!=JSON.stringify(r);
  //     return result;
  // }

  public async saveCurrentItemChanges() {
    if (!this.isVersionValid()) {
      return;
    }
    if (!this.selectedVersion.InstallerBLOB) {
      this.makeToast(
        `invalid installer to upload (be sure it ends with .msi)`,
        "danger"
      );
      return;
    }

    // const reader = new FileReader();
    // reader.onload = e => {
    //     this.setSelectedInstallerBLOB_(reader.result);
    // };
    // reader.readAsBinaryString(this.selectedVersion.InstallerBLOB);
    const client = this.hostname === "ers" ? "ERSPowerpoint" : "GenieBot";

    const u = {
      VERSION: this.selectedVersion.Version,
      ClientCategory: client,
      "Release-Notes": this.selectedVersion.ReleaseNotes,
      // InstallerMSI: await Plugins.cvtBLOB2Base64_(
      //   this.selectedVersion.InstallerBLOB
      // ),
    };
    this.isBusy = true;
    this.uploadPercentage = 0;
    await axios.post("/api/v4/Client/Installer", u).then(
      (response) => {
        this.saveInstaller();
      },
      (error) => {
        this.isBusy = false;
        this.makeToast(
          `Plugin version could not be saved, please try again later. ${
            error.message
          }`,
          "danger"
        );
      }
    );
  }

  public async saveInstaller() {
    const client = this.hostname === "ers" ? "ERSPowerpoint" : "GenieBot";

    await axios
      .put(
        `/api/v4/Client/Installer/${client}/${
          this.selectedVersion.Version
        }?content=Installer-MSI`,
        this.selectedVersion.InstallerBLOB,
        {
          headers: {
            "Content-Type": "application/octet-stream",
          },
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = Math.min(
              90,
              (progressEvent.loaded / progressEvent.total) * 100
            );
          },
        }
      )
      .then(
        (response) => {
          this.isBusy = false;
          this.uploadPercentage = 100;
          this.loadVersions();
          this.makeToast("Plugin version saved!");
        },
        (error) => {
          this.isBusy = false;
          this.makeToast(
            `Plugin version could not be saved, please try again later. ${
              error.message
            }`,
            "danger"
          );
        }
      );
  }

  public isVersionValid(user?) {
    const validVer = /^(\d+\.)(\d+\.)(\d+\.)(\d+)$/;

    let u = this.selectedVersion;
    if (user) {
      u = user;
    }

    if (
      !u.Version ||
      u.Version.trim() === "" ||
      !u.Version.trim().match(validVer)
    ) {
      this.makeToast(
        "Enter a valid 4 part digits only Version number - X.X.X.X",
        "danger"
      );
      return false;
    }
    return true;
  }

  public deleteVersion(version?) {
    this.isBusy = true;
    let v = this.selectedVersion.Version;
    if (version) {
      v = version;
    }
    const client = this.hostname === "ers" ? "ERSPowerpoint" : "GenieBot";
    axios.delete(`/api/v4/Client/Installer/${client}/${v}`).then(
      (response) => {
        this.isBusy = false;
        this.makeToast(`Plugin Version ${v} Deleted!`);
        this.loadVersions();
      },
      (error) => {
        this.isBusy = false;
        this.makeToast(
          `Plugin Version ${v} could not be deleted, please try again later.`,
          "danger"
        );
      }
    );
  }

  public makeToast(msg, vrant = "success") {
    this.$bvToast.toast(`${msg}`, {
      title: "Operation Completed",
      autoHideDelay: 3000,
      variant: vrant,
      appendToast: false,
    });
  }

  // Take the already downloaded installer and make it appear to the user as a download
  public fetchInstaller() {
    const url = window.URL.createObjectURL(this.selectedVersion.InstallerBLOB);
    const link = document.createElement("a");
    link.href = url;
    const client = this.hostname === "ers" ? "ERSPowerpoint" : "GenieBot";
    link.setAttribute(
      "download",
      `${client} Addin Installer ${this.selectedVersion.Version}.msi`
    );
    document.body.appendChild(link);
    link.click();
  }

  public cancel() {
    this.selectedVersion = this.emptyVersion();
  }

  public rowSelected(items) {
    if (items.length > 0) {
      const u = items[0];
      this.uploadPercentage = 0;
      this.selectedVersion.Version = u.Version;
      this.selectedVersion.ReleaseNotes = u.ReleaseNotes;
      this.pluginFile = null;
      this.setSelectedInstallerBLOB_(null, "checking...");
      this.addingNewVersion = false;

      const client = this.hostname === "ers" ? "ERSPowerpoint" : "GenieBot";
      this.isBusy = true;
      axios({
        url: `/api/v4/Client/Installer/${client}/${
          this.selectedVersion.Version
        }?return=msi-only`,
        method: "GET",
        responseType: "blob",
        onDownloadProgress: (progressEvent) => {
          this.uploadPercentage = Math.min(
            99,
            (progressEvent.loaded / progressEvent.total) * 100
          );
        },
      }).then(
        (response) => {
          this.setSelectedInstallerBLOB_(new Blob([response.data]));
          this.selectedVersion.SaveInstaller = false;
          this.isBusy = false;
        },
        (error) => {
          this.selectedVersion.InstallerSizeText = "no installer found";
          this.makeToast("error retrieving installer", "danger");
          this.isBusy = false;
        }
      );
    }
  }

  private setSelectedInstallerBLOB_(b, msg?: string) {
    if (b != null && !(b instanceof Blob)) {
      throw new Error("oops"); // assert failure()
    }
    this.selectedVersion.InstallerBLOB = b;
    if (!msg) {
      if (b == null) {
        msg = "none";
      } else {
        msg = `${(b.size / (1024 * 1024)).toFixed(3)} MB`;
      }
    }
    this.selectedVersion.InstallerSizeText = msg;
  }

  private processVersionsAvailable_(d) {
    this.versionsAvailable.splice(0, this.versionsAvailable.length);
    const keys: any = Object.keys(d);
    const vals: any = Object.values(d);
    for (const k of keys) {
      const v = d[k];
      v.Version = d[k].Version;
      v.ReleaseNotes = d[k]["Release-Notes"];
      this.versionsAvailable.push(v);
    }
    this.totalRows = this.versionsAvailable.length;
  }
}
